import { assertIsDefined } from '@sgme/fp';

const decimalSeparators = [',', '.'] as const;
type DecimalSeparator = (typeof decimalSeparators)[number];

const cleanupRegexes: Record<DecimalSeparator, RegExp> = {
  ',': /[. ]/g,
  '.': /[, ]/g,
};

export const cleanupNumberWith = (fieldDelimiter: string) => {
  const guessDecimalSeparator = guessDecimalSeparatorWith(fieldDelimiter);
  return (value: string, isNotional = false) => {
    const guessedSeparator = guessDecimalSeparator(value, isNotional);
    return value?.replace(cleanupRegexes[guessedSeparator], '');
  };
};

export const guessDecimalSeparatorWith =
  (fieldDelimiter: string) =>
  (value: string, isNotional = false): DecimalSeparator => {
    if (fieldDelimiter === ',') {
      return '.';
    }
    const candidatesSeparators = decimalSeparators
      .map((s) => [s, value.lastIndexOf(s)] as const)
      .sort(([, i1], [, i2]) => i2 - i1)
      .filter(([s]) => {
        const splits = value.split(s);

        if (!isNotional) {
          return splits.length === 2;
        }

        if (splits.length !== 2) {
          return splits.length === 1;
        }

        const lastPart = splits[1];
        assertIsDefined(lastPart, 'splits has exactly 2 elements here');

        return lastPart.length !== 3;
      });
    const bestCandidate = candidatesSeparators[0];
    if (bestCandidate === undefined) {
      return ',';
    }
    return bestCandidate[0];
  };
